import request from "../request";

export default {
  // 评论-新增
  create(data) {
    return request.post("/comment/commit", data);
  },

  // 评论-更新
  edit(data) {
    return request.post("/comment/edit", data);
  },

  // 评论-我的
  myComment(data) {
    return request.get("/comment/myComment", data);
  },

  // 评论-列表
  lists(data) {
    return request.get("/comment/lists", data);
  },

  // 评论-删除
  delete(data) {
    return request.post("/comment/delete", data);
  },

  // 评论-回复列表
  listAll(data) {
    return request.get("/comment/listAll", data);
  },

  // 评论-根据id获取
  updateStatus(data) {
    return request.post("/comment/updateStatus", data);
  },

};
